var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bnb"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9707 24.7793C19.5876 24.7793 24.9707 19.3823 24.9707 12.7483C24.3118 -3.21255 1.62743 -3.20817 0.970703 12.7483C0.970703 19.3823 6.35379 24.7793 12.9707 24.7793Z",
    fill: "#F2C94C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5853 10.7209C10.1918 13.2037 10.194 12.2942 12.5853 14.7748C12.7986 14.9887 13.1433 14.9887 13.3566 14.7748L14.9929 13.1348C15.204 12.9313 15.2046 12.5649 14.9929 12.3615L13.3566 10.7209C13.1433 10.5071 12.7986 10.5071 12.5853 10.7209Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.30804 12.0409C9.51258 12.246 9.87476 12.246 10.0793 12.0409L12.9664 9.14638L15.8535 12.0409C16.0564 12.2526 16.4219 12.2531 16.6248 12.0409L18.2611 10.4003C18.4744 10.1865 18.4744 9.8409 18.2611 9.62708L13.352 4.70529C13.1388 4.49147 12.794 4.49147 12.5808 4.70529L7.67167 9.62708C7.4584 9.8409 7.4584 10.1865 7.67167 10.4003L9.30804 12.0409Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.9896 12.3608C18.5133 9.96225 19.4209 9.96389 16.9456 12.3608C16.7345 12.5642 16.734 12.9306 16.9456 13.1341L18.582 14.7747C18.7953 14.9885 19.14 14.9885 19.3533 14.7747L20.9896 13.1341C21.2007 12.9306 21.2013 12.5642 20.9896 12.3608Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.94759 12.3608C7.42395 9.96225 6.51631 9.96389 8.99159 12.3608C9.20268 12.5642 9.20322 12.9306 8.99159 13.1341L7.35522 14.7747C7.14195 14.9885 6.79722 14.9885 6.58395 14.7747L4.94759 13.1341C4.73649 12.9306 4.73595 12.5642 4.94759 12.3608Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16.6248 13.4548C16.4202 13.2498 16.058 13.2498 15.8535 13.4548L12.9664 16.3494L10.0793 13.4548C9.8764 13.2432 9.51095 13.2426 9.30804 13.4548L7.67167 15.0954C7.4584 15.3093 7.4584 15.6549 7.67167 15.8687L12.5808 20.7905C12.794 21.0043 13.1388 21.0043 13.352 20.7905L18.2611 15.8687C18.4744 15.6549 18.4744 15.3093 18.2611 15.0954L16.6248 13.4548Z",
    fill: "#F7F7F7"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.3817518f525d3358acace3e559c7ad4f.svg";
export { ForwardRef as ReactComponent };